import React from "react";
import { Button } from "reactstrap";

interface Props {
  onClick: () => void;
  disabled: boolean;
}

export default ({ onClick, disabled }: Props) => (
  <div className="text-right">
    <Button
      color="secondary"
      onClick={e => {
        e.preventDefault();
        onClick();
      }}
      size="sm"
      disabled={disabled}
    >
      Registrar Nueva Actividad
    </Button>
  </div>
);
